import BaseComponent from "./BaseComponent";
import C_Entity from "../../const/C_Entity";
import Physics from "./Physics";
import GameSprite from "./GameSprite";
import FlierLogic from "./FlierLogic";
import C_Snd from "../../const/C_Snd";
import Point3D from "../math/Point3D";
import C_ViewType from "../../const/C_ViewType";
import MathUtil from "../utils/MathUtil";
import C_GameEvt from "../const/C_GameEvent";

class FriendlyBot extends BaseComponent
{
    constructor(data, id)
    {
        super();
        // this.botId = id;
        // this.data = data;
        // this.isInit = false;
        //
        //
        // this.positionZ = 40;
        // this.shipHeight = 25; // in Percents
        // this.allyShip = this.app.assets.getSprite("allied_ship");
        // this.app.layout.propHeightScale(this.allyShip, this.shipHeight);
        // this.allyShip.scale.x *= data.scale;
        // this.allyShip.anchor.set(.1, .1);
        // this.app.layout.verticalAlignTop(this.allyShip);
        // this.allyShip.x = data.positionX;
        // this.shipWidth = (this.allyShip.width / this.app.layout.relWidth(100)) * 100; // in Percents
        //
        // this.weapPos = new Point3D(0, 0, 0);
        // this.projCounter = 0;
        // this.newTargetTimer = 12;
        // this.shootDelay = 0.5;
        // this.canShoot = true;
        //
        // this.botBalance = Math.floor(this.app.model.getBalance()*MathUtil.getRandomFloat(0.5, 2));
        // this.app.model.setBot(this);

        this.isInit = false;

        // data
        this.botId = id;
        this.data = data;
        this.botBalance = Math.floor(this.app.model.getBalance()*MathUtil.getRandomFloat(0.5, 2));
        this.badgeId = data.badgeId;

        // UI
        this.totalBadges = 6;
        this.shipHeights = [9, 9, 8, 9, 9, 9];
        this.balancePosX = { // from left
            1: [60, 57, 59, 55, 57, 56],
            2: [17, 17, 17, 18, 18, 17]
        }
        this.balancePosY = [-18, -20, -1, 5, -11, -23] // from middle
        this.namePosX = { // from center
            1: [ 20,  19,  20,  15,  20, 17],
            2: [-20, -19, -19, -15, -20, -17]
        }
        this.namePosY = [.7, .7, .95, .93, .7, .65]; // from height
        this.topPad = 1;
        this.shipHeight = 10; // in Percents
        this.textHeight = this.coinHeight = 2.5; // in Percents
        this.nameHeight = 2;
        this.mv = this.entitySystem.mainView;
        this.addUI();
        this.shipWidth = (this.allyBadge.width / this.app.layout.relWidth(100)) * 100; // in Percents

        // Bot projectiles and variables
        this.positionZ = 40;

        this.app.model.setBot(this);
    }


    addUI()
    {
        this.sprites = []; // used for cleaning

        // let badge = MathUtil.getRandomInt(0, this.totalBadges - 1);
        // badge = 5;
        let position = this.data.postfix;
        let badgeTexture = "bot_banner_" + this.badgeId + position;
        let height = this.shipHeights[this.badgeId];
        let balX = this.balancePosX[this.botId][this.badgeId];
        let balY = this.balancePosY[this.badgeId];
        let nameX = this.namePosX[this.botId][this.badgeId];
        let nameY = this.namePosY[this.badgeId];
        let pad = this.app.layout.relWidth(0.5);

        this.allyBadge = this.app.assets.getSprite(badgeTexture);
        this.app.layout.propHeightScale(this.allyBadge, height);
        this.app.layout.verticalAlignTop(this.allyBadge, this.topPad);
        this.allyBadge.x = this.data.positionX - this.allyBadge.width * this.data.offXWidthScale;
        this.sprites.push(this.allyBadge);


        this.allyBadgeGlow = this.app.assets.getSprite(badgeTexture + "_glow");
        this.app.layout.propHeightScale(this.allyBadgeGlow, height);
        this.allyBadgeGlow.x = this.allyBadge.x;
        this.allyBadgeGlow.y = this.allyBadge.y;
        this.sprites.push(this.allyBadgeGlow);
        this.allyBadgeGlow.alpha = 0

        this.allyPointsBg = this.app.assets.getSprite("bot_pointsBg_" + this.badgeId + position);
        this.app.layout.propHeightScale(this.allyPointsBg, height);
        this.allyPointsBg.x = this.allyBadge.x;
        this.allyPointsBg.y = this.allyBadge.y;
        this.sprites.push(this.allyPointsBg);

        this.balanceTF = this.app.assets.getTF(this.botBalance, this.app.layout.relHeight(this.textHeight));
        this.app.layout.horizontalAlignLeft(this.balanceTF, balX, this.allyBadge);
        this.app.layout.verticalAlignMiddle(this.balanceTF, balY, this.allyBadge);
        this.sprites.push(this.balanceTF);

        this.coinImg = this.app.assets.getSprite("coin");
        this.app.layout.propHeightScale(this.coinImg, this.coinHeight);
        this.coinImg.x = this.balanceTF.x - this.coinImg.height - pad;
        this.coinImg.y = this.balanceTF.y;
        this.sprites.push(this.coinImg);

        this.botName = this.app.assets.getTF(this.data.name, this.app.layout.relHeight(this.nameHeight));
        this.app.layout.horizontalAlignCenter(this.botName, nameX, this.allyBadge);
        //this.app.layout.verticalAlignMiddle(this.botName, 0, this.allyShip);
        this.botName.y = this.allyBadge.y + this.allyBadge.height*nameY;
        this.sprites.push(this.botName);
    }


    playShootAnim()
    {
        TweenMax.killTweensOf(this.allyBadgeGlow);
        TweenMax.to(this.allyBadgeGlow, .05, {alpha: 1});
        TweenMax.to(this.allyBadgeGlow, .1, {alpha: 0, delay: .05})
    }


    setBotRoom(roomId)
    {
        this.botRoomId = roomId;
        this.weapRelPos = this.data.projectileRelPos[roomId];
    }


    getBotRoom()
    {
        return this.botRoomId;
    }


    getBadgeId()
    {
        return this.badgeId;
    }


    init()
    {
        // this.weap1PercPosition = this.shipPointToScreenPercent(new PIXI.Point(50 + (45-10)*this.data.scale, 90-10)); // bottom right corner of the allyShip. -10 cause of anchor point
        // this.weap2PercPosition = this.shipPointToScreenPercent(new PIXI.Point(50 + (17-10)*this.data.scale, 100-10));


        /*this.weap1PercPosition = this.shipPointToScreenPercent(new PIXI.Point(100-10, 84-10)); // bottom right corner of the allyShip. -10 cause of anchor point
        this.weap2PercPosition = this.shipPointToScreenPercent(new PIXI.Point(68-10, 98-10));
        let deltaX = this.app.layout.getGameToScreenXRatio()*(5/6);
        let deltaY = this.app.layout.getGameToScreenYRatio()*(5/6);
        this.ingameWeapPosition = [
            new PIXI.Point(this.weap1PercPosition.x*deltaX/50, this.weap1PercPosition.y*deltaY/50),
            new PIXI.Point(this.weap2PercPosition.x*deltaX/50, this.weap2PercPosition.y*deltaY/50),
        ];*/

        this.mv.botsContainer.addChild(this.allyBadge);
        this.mv.botsContainer.addChild(this.allyBadgeGlow);
        this.mv.botsContainer.addChild(this.allyPointsBg);
        this.mv.botsContainer.addChild(this.coinImg);
        this.mv.botsContainer.addChild(this.balanceTF);
        this.mv.botsContainer.addChild(this.botName);


        this.scheduleNewTargetTimer();
        this.scheduleNextShot();
        this.scheduleAcquireTargetDelay();
        this.canShoot = true;
        this.isInit = true;
    }


    shipPointToScreenPercent(shipPoint)
    {
        // -50% because x/y=0 is in the middle
        let x = ((shipPoint.x/100) * this.shipWidth - 50)*this.data.scale;
        let y = (shipPoint.y/100) * this.shipHeight - 50;
        return new PIXI.Point(x, y);
    }


    setWeapPos(relPt)
    {
        let posZ = this.positionZ;
        let posX = ((relPt.x-(0.5))*2*this.app.controller.deltaXExtra + this.ingameWeapPosition[this.projCounter%2].x)*this.app.layout.getProjectedConst(posZ);
        let posY = (((relPt.y-(0.5))*2*this.app.controller.deltaYExtra + this.ingameWeapPosition[this.projCounter%2].y))*this.app.layout.getProjectedConst(posZ);

        this.weapPos.x = posX;
        this.weapPos.y = posY;
        this.weapPos.z = posZ;
    }


    getWeapPos(id)
    {
        let weapRelPos = this.weapRelPos[id].clone();
        // let weapRelPos = new PIXI.Point(5, 5);
        // let weapRelPos = this.weapRelPos.clone();

        let weapPos = new PIXI.Point(this.app.layout.relWidth(weapRelPos.x), this.app.layout.relHeight(weapRelPos.y));
        weapPos = this.mv.mainContainer.toLocal(this.mv.toGlobal(weapPos));
        let weapScreenToGame = this.app.layout.projectScreenToGame3D(weapPos, this.positionZ);

        return weapScreenToGame;
    }


    shoot()
    {
        if (!this.makeBet() || !this.canShoot)
        {
            return;
        }
        this.playShootAnim();

        // need this point (the target point) to make a correct spawn position of the friendly ship
        // let relPt = this.app.controller.getShootPt();
        // if (!relPt) return;
        // relPt = this.app.layout.globalToRelative(relPt);
        //
        // this.setWeapPos(relPt);


        let projVelocity = this.app.model.getProjectileVelocity();

        let shootVector = this.target.position.clone();
        // shootVector.x += (1 - Math.random()*2)*this.target.getCollisionRadius()*1.3;
        // shootVector.y += (1 - Math.random()*2)*this.target.getCollisionRadius()*1.3;
        let targetVelocity = this.target.velocity.clone();
        targetVelocity.scale((shootVector.getLength()/projVelocity));
        shootVector = shootVector.add(targetVelocity);


        //test
        // shootVector = new Point3D(0, 0, 0);

        let projSize = this.botRoomId != 1 ? 2.5 : 4;
        let endShootVector;
        let weapPos;
        let pos;
        if (this.botRoomId == 0)
        {
            weapPos = this.getWeapPos(0);
            pos = new Point3D(weapPos.x, weapPos.y, this.positionZ);
            endShootVector = this.getEndShootVector(pos, shootVector, projVelocity, 0);

            let p = this.app.eFactory.getProjectile(pos, endShootVector, projSize, this.botRoomId, this.botId);
            this.entitySystem.queueEntityToAdd(p);
        }
        else if (this.botRoomId == 1)
        {
            // projectile 1
            weapPos = this.getWeapPos(0);
            pos = new Point3D(weapPos.x, weapPos.y, this.positionZ);
            endShootVector = this.getEndShootVector(pos, shootVector, projVelocity, 0);

            let p = this.app.eFactory.getProjectile(pos, endShootVector, projSize, this.botRoomId, this.botId);
            this.entitySystem.queueEntityToAdd(p);

            // projectile 2
            weapPos = this.getWeapPos(1);
            pos = new Point3D(weapPos.x, weapPos.y, this.positionZ);
            endShootVector = this.getEndShootVector(pos, shootVector, projVelocity, 0);

            p = this.app.eFactory.getProjectile(pos, endShootVector, projSize, this.botRoomId, this.botId);
            this.entitySystem.queueEntityToAdd(p);
        }
        else if (this.botRoomId == 2)
        {
            // projectile 1
            weapPos = this.getWeapPos(0);
            pos = new Point3D(weapPos.x, weapPos.y, this.positionZ);
            endShootVector = this.getEndShootVector(pos, shootVector, projVelocity, 0);

            let p = this.app.eFactory.getProjectile(pos, endShootVector, projSize, this.botRoomId, this.botId);
            this.entitySystem.queueEntityToAdd(p);

            // projectile 2
            weapPos = this.getWeapPos(1);
            pos = new Point3D(weapPos.x, weapPos.y, this.positionZ);
            endShootVector = this.getEndShootVector(pos, shootVector, projVelocity, 0);

            p = this.app.eFactory.getProjectile(pos, endShootVector, projSize, this.botRoomId, this.botId);
            this.entitySystem.queueEntityToAdd(p);

            // projectile 3
            weapPos = this.getWeapPos(2);
            pos = new Point3D(weapPos.x, weapPos.y, this.positionZ);
            endShootVector = this.getEndShootVector(pos, shootVector, projVelocity, 0);

            p = this.app.eFactory.getProjectile(pos, endShootVector, projSize, this.botRoomId, this.botId);
            this.entitySystem.queueEntityToAdd(p);
        }
        // this.projCounter++;
    }


    getEndShootVector(pos, shootVector, projVelocity)
    {
        let endShootVector = shootVector.subtract(pos);
        endShootVector.normalize();
        endShootVector.scale(projVelocity);

        return endShootVector;
    }


    makeBet()
    {

        let canShoot = this.app.eSys.botsCanShoot;

        if (this.botBalance < this.app.model.getBet())
        {
            canShoot = false;
            this.lifeTime = 0;
        }
        else if (canShoot)
        {
            this.botBalance -= this.app.model.getBet();
            this.updateBalance();
            // this.app.dispatcher.emit(C_GameEvt.BOT_BALANCE_UPDATE, this.botId);
        }
        return canShoot;
    }


    addToBalance()
    {
        this.botBalance += this.app.model.getBet() * MathUtil.getRandomInt(15, 30);
        this.updateBalance();
        // this.app.dispatcher.emit(C_GameEvt.BOT_BALANCE_UPDATE, this.botId);
    }


    updateBalance()
    {
        this.balanceTF.text = this.botBalance;
    }


    setTarget(target)
    {
        this.target = target;
    }


    getTarget()
    {
        return this.target;
    }


    scheduleNewTargetTimer()
    {
        this.newTargetTimer = 8 + Math.random()*4;
    }


    scheduleNextShot()
    {
        this.shootCooldown = 0.8;
    }


    scheduleAcquireTargetDelay()
    {
        this.acquireTargetDelay = 0.4;
    }


    update(delta)
    {
        if (!this.isInit) return;

        this.acquireTargetDelay -= delta;
        this.newTargetTimer -= delta;
        if(this.newTargetTimer < 0)
        {
            this.acquireTarget();
            this.scheduleNewTargetTimer();
        }


        this.shootCooldown -= delta;

        //test
        // if (this.shootDelay < 0)
        // {
        //     this.shoot();
        //     this.scheduleNextShot();
        // }
        // return;

        let t = this.getTarget();
        if (t)
        {
            let e = t.getEntity();
            let fl = e.getComponent(FlierLogic);

            if (!fl.isAlive || e.isRemoved)
            {
                this.acquireTarget();
            }
            else if (this.shootCooldown < 0)
            {
                this.shoot();
                this.scheduleNextShot();
            }
        }
        else
        {
            this.acquireTarget();
        }

        // life time
        this.getEntity().lifeTime -= delta;
    }


    acquireTarget()
    {
        if (this.acquireTargetDelay > 0) {
            return;
        }
        this.scheduleAcquireTargetDelay();
        let targets = this.entitySystem.getEntitiesByType(C_Entity.FLIER);

        if (targets && this.app.eSys.botsCanShoot)
        {
            // console.log("new target");
            let keys = Object.keys(targets);
            let t = targets[keys[ keys.length * Math.random() << 0]];
            if (t)
            {
                let p = t.getComponent(Physics);

                // TODO there happened a bug where this was triggering infinite times while transitioning to a Mini Game
                if (p.position.z < this.positionZ)
                {
                    this.acquireTarget();
                }
                else
                {
                    this.setTarget(p);
                }
            }

            // console.log(this.target);
        }
    }


    destroy()
    {
        super.destroy();

        let s;
        for (let i = 0; i < this.sprites.length; i++)
        {
            s = this.sprites[i];
            if (s.parent)
            {
                s.parent.removeChild(s);
            }
        }
        this.sprites = null;
    }
}

export default FriendlyBot;